<template>
  <td class="content" :colspan="headers.length">
    <v-row class="mt-3 mb-3">
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.squareMetersPrice') }}
        </h6>
        <span class="caption">
          {{ formatMoney(item.square_meter_price) }}
        </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.baseSquareMetersPrice') }}
        </h6>
        <span class="caption">
          {{ formatMoney(item.base_square_meters_size) }}
        </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.displacementTax') }}
        </h6>
        <span class="caption"> {{ item.displacement_tax }}% </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.taxSquareMeters') }}
        </h6>
        <span class="caption"> {{ item.square_meter_tax }}% </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.furnitureTax') }}
        </h6>
        <span class="caption"> {{ item.furniture_tax }}% </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.semiFurnitureTax') }}
        </h6>
        <span class="caption" v-if="item.semi_furniture_tax">{{ item.semi_furniture_tax }}%</span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.houseTax') }}
        </h6>
        <span class="caption" v-if="item.house_tax">{{ item.house_tax }}%</span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.trousseauTax') }}
        </h6>
        <span class="caption"> {{ item.trousseau_tax }}% </span>
      </v-col>
      <v-col cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.urgencyTax') }}
        </h6>
        <span class="caption" v-if="item.urgency_tax">
          {{ item.urgency_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col v-if="item.urgency_tax && item.urgency_tax > 0" cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.hostUrgencyTax') }}
        </h6>
        <span class="caption" v-if="item.host_urgency_tax">
          {{ item.host_urgency_tax }}%
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
      <v-col v-if="item.urgency_tax && item.urgency_tax > 0" cols="12" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('defaultServiceValues.label.urgencyHoursLimit') }}
        </h6>
        <span class="caption" v-if="item.urgency_hours_limit">
          {{ item.urgency_hours_limit }}h
        </span>
        <span class="caption" v-else>---</span>
      </v-col>
    </v-row>
  </td>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'TableServiceDetails',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatMoney(amount) {
      return catalogMonetary(parseFloat(amount))
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  padding: 30px;
  background-color: #fff;
}
</style>
